var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer-container"},[_c('div',[_vm._v("v"+_vm._s(_vm.version)+" © 2018")]),_vm._v(" "),_c('div',[(_vm.icp)?_c('span',[_vm._v(_vm._s(_vm.icp.name))]):_vm._e(),_vm._v(" "),(_vm.beian)?_c('span',[_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":_vm.beian.link,"target":"_blank"}},[_c('span',[_vm._v(_vm._s(_vm.beian.name))])])]):_vm._e()])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3defac4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Footer.vue
// module id = null
// module chunks = 